module.exports = __webpack_public_path__ + "img/icon_pdf.bd6b0293.svg";